<div class="modal">
  <div class="modal-overlay" (click)="cancel($event)"></div>

  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between">
        <h4 class="modal-title">{{ modalTitle }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel($event)"></button>
      </div>

      <div class="modal-body">
        <form id="userInformationSetDialog">
          @if (userCopy) {
            <div class="form-floating mt-2">
              <input class="form-control" type="text" disabled [value]="userCopy.coUserNumber" placeholder="" name="coUserNumberInputField" (change)="userCopy.coUserNumber = userCopy.coUserNumber?.trim()" />
              <label i18n="@@UserInformationSetcoUserNumberInputLabel">CoUserNumber</label>
            </div>
            <div class="form-floating mt-2">
              <input class="form-control" type="text" disabled [value]="userCopy.salutation" placeholder="" name="salutationInputField" (change)="userCopy.salutation = userCopy.salutation?.trim()" />
              <label i18n="@@UserInformationSetSalutationInputLabel">Salutation</label>
            </div>
            <div class="form-floating mt-2">
              <input class="form-control" type="text" disabled [value]="userCopy.firstName" placeholder="" name="nameInputField" (change)="userCopy.firstName = userCopy.firstName?.trim()" />
              <label i18n="@@UserInformationSetNameInputLabel">Name</label>
            </div>
            <!--
                  <div class="form-floating mt-2">
                    <input class="form-control" type="text" disabled [value]="user.lastName" placeholder=""
                      name="lastNameInputField">
                      <label i18n="@@UserInformationSetLastNameInputLabel">Lastname</label>
                    </div>
                    -->
            <div class="form-floating mt-2">
              <input class="form-control" type="text" [pattern]="inputValidationEmailRegexPattern" [(ngModel)]="userCopy.eMail" placeholder=" " required name="eMailInputField" maxlength="80" (change)="userCopy.eMail = userCopy.eMail?.trim()" />
              <label i18n="@@UserInformationSetEMailInputLabel">E-Mail</label>
            </div>
            <!--
                      <div class="form-floating mt-2">
                        <input class="form-control" type="text" [(ngModel)]="userCopy.userAlias" placeholder=" " name="aliasInputField" (change)="userCopy.userAlias = userCopy.userAlias?.trim()">
                        <label i18n="@@UserInformationSetAliasInputLabel">Alias</label>
                      </div>
                      -->
            <div class="mt-3">
              <app-check-send-confirmation [isChecked]="userCopy.confirmationIsPreselected" (onChecked)="userCopy.confirmationIsPreselected = $event"></app-check-send-confirmation>
            </div>
            @if (displayNewsletterSubscription) {
              <div class="mt-3">
                <app-check-newsletter [isChecked]="userCopy.newsletterSubscribed" (onChecked)="userCopy.newsletterSubscribed = $event"></app-check-newsletter>
              </div>
            }
          }
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="submitAsync($event)">{{ submitButtonLabel }}</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel($event)">{{ cancelButtonLabel }}</button>
      </div>
    </div>
  </div>
</div>
